import BaseItemView from 'app/src/views/base/BaseItemView';

import detailHeaderView from './templates/detail-header-view.hbs';

// configure
let View = BaseItemView.extend({
  className: 'one.column',
  template: detailHeaderView,
});

// define
export default class DetailHeaderView extends View {
  addButton(button) {
    this.$el.append(button);
  }
}
